import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import ArrowIcon from './right-arrow.svg';

const useStyles = makeStyles(() => ({
  center: {
    display: 'flex',
    alignItems: 'center',
  },
  root: {
    textDecoration: 'none',
    ' & p': {
      marginLeft: 20,
      fontSize: 14,
      '& img': {
        marginBottom: 2,
      },
    },
  },
}));

function DiscoverLink({ link, label, clickHandler, center }) {
  const classes = useStyles();
  return (
    <Grid item className={center && classes.center}>
      <Link to={link} className={classes.root} onClick={clickHandler}>
        <Typography>
          {label} <img src={ArrowIcon} alt="" />
        </Typography>
      </Link>
    </Grid>
  );
}
DiscoverLink.propTypes = {
  link: PropTypes.string,
  label: PropTypes.string,
  clickHandler: PropTypes.func,
};

DiscoverLink.defaultProps = {
  label: 'DISCOVER MORE',
  clickHandler: () => {},
};

export default DiscoverLink;
